import { EnterNewEmailTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const EnterNewEmailTrackingSchema: Record<
  EnterNewEmailTrackingPoint,
  string
> = {
  [EnterNewEmailTrackingPoint.PageView]: '9abe7b52-bc4f-4f79-81fe-5464d0e4b7d1',
  [EnterNewEmailTrackingPoint.NextButtonClick]:
    '02dea6d9-d0c5-4a83-8b13-57bf16373b82',
  [EnterNewEmailTrackingPoint.BackButtonClick]:
    '20611921-8c6e-4dc6-8097-8c7d839a5c3e',
  [EnterNewEmailTrackingPoint.HelpButtonClick]:
    'b02f0ae1-5ccb-41fa-afe8-fd145cd3fd26',
};

export const getEnterNewEmailPageTypeAndSchema = (
  trackingPoint: EnterNewEmailTrackingPoint
) => {
  return {
    page_type: PageType.EnterNewEmailPage,
    schema: EnterNewEmailTrackingSchema[trackingPoint],
  };
};
